import { Component, EventEmitter, OnInit, Output,Input } from '@angular/core';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { Tank } from 'src/app/shared/models/Tank';
import { User } from 'src/app/shared/models/User';
import { Vehicle } from 'src/app/shared/models/Vehicle';

@Component({
  selector: 'discharge-filter',
  templateUrl: './discharge-filter.component.html',
  styleUrls: ['./discharge-filter.component.css']
})
export class DischargeFilterComponent implements OnInit {


  @Output() filterApplied = new EventEmitter<any>();
  @Input() fuel_names: string[];

  currentTank: Tank;
  users: User[];
  vehicles: Vehicle[];
  dateFrom;
  dateTo;
  status;
  selectedStatus = null;
  selectedUser = null;
  selectedVehicle = null;
  selectedBusinessName = null;
  selectedFuel = null;
  range = [0, 50000];

  filter = {
    dateFrom: null,
    dateTo: null,
    user: null,
    vehicle: null,
    businessName: null,
    status: null,
    fuel_name: null,
    amountFrom: 0,
    amountTo: 50000,
  };

  voucherStatus: string[] = ['EXITO', 'ERROR'];

  constructor(private tankService: TankService, private userService: UserService, private vehicleService: VehicleService) { }


  ngOnInit() {
    this.tankService.getCurrentTank().subscribe((tank) => {
      this.currentTank = tank;
      // console.log('tanque: ', tank);
      // Después de obtener el tanque, obtenemos la lista de usuarios.
      this.listUsers();
      this.listVehicles();
      
    });

  }

  listUsers() {

    this.userService.getUsersByTank(this.currentTank.id).subscribe(
      (users) => {
        this.users = users;
      }, (error) => {
        console.log(error);
      }
    );

  }

  listVehicles() {
    this.vehicleService.getVehicleByTank(this.currentTank.id).subscribe(
      (vehicles) => {
        this.vehicles = vehicles;
      }, (error) => {
        console.log(error);
      }
    );

  }

  applyFilter() {
    // console.log(this.selectedFuel)
    if (this.dateFrom) {
      this.filter.dateFrom = new Date(this.dateFrom.year, this.dateFrom.month - 1, this.dateFrom.day);
    } else { this.filter.dateFrom = null; }
    if (this.dateTo) {
      this.filter.dateTo = new Date(this.dateTo.year, this.dateTo.month - 1, this.dateTo.day + 1);
    } else { this.filter.dateTo = null; }
    this.filter.user = this.selectedUser;
    this.filter.fuel_name = this.selectedFuel;
    this.filter.status = this.selectedStatus ? this.selectedStatus : null;
    this.filter.vehicle = this.selectedVehicle;
    this.filter.businessName = this.selectedBusinessName;
    this.filter.amountFrom = this.range[0];
    this.filter.amountTo = this.range[1];
    this.filterApplied.emit(this.filter);
  }

    showFilters: boolean = false;

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

}
